import { Component, OnInit, Input, Inject, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { AuthService, FirestoreService } from 'src/app/services/service.index';
import { AngularFireStorage } from '@angular/fire/storage';
import { DOCUMENT } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-editcustomerform',
  templateUrl: './editcustomerform.component.html',
  styleUrls: ['./editcustomerform.component.css']
})
export class EditcustomerformComponent implements OnInit {


  @Input('address') adressType: any;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @Output() addressGoogle: EventEmitter<any> = new EventEmitter();
  @ViewChild('addresstext') addresstext: any;

  autocompleteInput: string;
  registro:any = {};
  queryWait: boolean;

  @Input() user: any;

  // Accessing HTML Element
  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;



urlImg:any = "../../../assets/img/images.jpeg";
imageTemp: string;

cliente:any = {};

selectedFile: File = null;
uploadPercent: Observable<number>;
downloadURL: Observable<string>;

activo = false;

mensajeArchivo = '';
nombreArchivo = '';

porcentaje :any ='';
snapshot:any;
finalizado = false;
total = 0;
img = false;

nueva:any;

banDir = false;

address:any = {};
addressDir:any = null;

lat:any;
lng:any;

productLat;
productLong;
userLat;
userLong;
map: google.maps.Map;
listingPlace;
distanceProductToUser;
marker:any;

regionName:any;
region:any;


forma = new FormGroup({
  id: new FormControl(),
  companyname: new FormControl( null, Validators.required),
  firstnamecontact: new FormControl( null, Validators.required),
  lastnamecontact: new FormControl(),
  phone: new FormControl(),
  identification: new FormControl(),
  typeuser: new FormControl("CUS"),
  address: new FormControl(" "),
  description: new FormControl(" "),
  region: new FormControl(""),
  houropen: new FormControl(),
  hourclose: new FormControl(),
  latitude:  new FormControl(0),
  longitude: new FormControl(0),
  email: new FormControl(null, [Validators.required, Validators.email]),
  status: new FormControl(true),
  role: new FormControl("US")
}, {
   // validators: this.samePassword('password','password2')
});




constructor(@Inject(DOCUMENT) private document, private afs: FirestoreService, private storage: AngularFireStorage, private activatedRoute: ActivatedRoute,  private router: Router, private authService: AuthService) { }


ngAfterViewInit() {

    this.getPlaceAutocomplete();

}

mapInitializer(resp) {

  // place your product lat or longtitude here
  this.productLat = resp.latitude;// change it to your preferences
  this.productLong = resp.longitude; // <-- static
  const coordinates = new google.maps.LatLng(this.productLat, this.productLong); // init our coordinate for marker :)
  this.marker = new google.maps.Marker({
    position: coordinates,
    map: this.map
  })
  // check here to get to know about map options docs
  const mapOptions: google.maps.MapOptions = {
  // here to place centering our location based on coordinates
  center: coordinates,
  zoom: 18,
  fullscreenControl: false,
  mapTypeControl: false,
  streetViewControl: false
  };
  //set our lovely google maps here and marker here
  this.map = new google.maps.Map(this.gmap.nativeElement, mapOptions);
  this.marker.setMap(this.map);
  // get address name based on latitude and longtitude
  // here we do Reverse Geocoding technique that convert Latitude and // longtitude to be lovely human readable information like address
  /*this.getProductAddressMap().subscribe((data: any) => {

    this.listingPlace =  data.results[1].address_components[0].short_name;

  })*/

  }



  ngOnInit(): void {

    this.user = this.afs.usersShow;


    this.activatedRoute.params.subscribe(params => {

      //console.log(params.id);

      this.afs.getCustomerByCompany(this.user.companyId, params.id).subscribe((resp:any) => {

          this.address = resp.address;

          this.mapInitializer(resp);

          this.initValueForm(resp);

      });

    });
   }


   initValueForm(user: any){

   // this.urlImg = user.img || this.urlImg;
   // this.id = user.id;



    this.forma.patchValue({
      id: user.id,
      companyname: user.companyname,
      firstnamecontact: user.firstnamecontact,
      lastnamecontact: user.lastnamecontact,
      identification: user.identification,
      phone: user.phone,
      region: user.region,
      latitude: user.latitude,
      longitude: user.longitude,
      address: user.address,
      typeuser: user.typeuser,
      email: user.email,
      status: user.status,
      houropen: user.houropen,
      hourclose: user.hourclose,
      description: user.description,
      role: user.role
    });

    this.getRegionCustomer(user.latitude, user.longitude);

  }

  updateCustomer(){

      //console.log(this.forma.value);

      if(this.forma.invalid){
        return;
      }

      let data = {};
      let regions = {};
      data = this.forma.value;
      regions[this.region] = true;
      data['regions']=regions;

      this.afs.updateCustomerByCompany(this.user.companyId, this.forma.value.id, this.forma.value).then((resp) => {

        //this.afs.saveStorage(this.forma.value.id, this.forma.value);


        Swal.fire('Good job!', 'Customer ha been updated!!!!', 'success');

        this.router.navigate(['/customers']);

    }).catch((err) =>{

       Swal.fire('Oops...', 'Customer has not been updated!!', 'error');

    })
  }


  getRegionCustomer(lat, lng){


    this.afs.getAllRegionPro(this.user.companyId).then(res =>{

      res.forEach((doc)=>{
          //console.log(doc.id);
          //console.log(doc.data());

          let location = [ lat, lng];

          let idRegion = doc.id;
          let regionData = doc.data();
          let regionPolygon = doc.data().polygon;

          let  pointArr = [];

          Object.keys(regionPolygon).forEach((id) => {
              var point = [
                  regionPolygon[id].lat,
                  regionPolygon[id].lng,
              ];
              pointArr.push(point);
          });

          //console.log(pointArr);

          if(this.afs.inside(location, pointArr)){
              //console.log(regionData.name);
              this.regionName = regionData.name;
              this.region = idRegion;
              this.forma.controls['region'].setValue(this.regionName);
          }

      });

  }).catch(err=>{
      console.log(err);
  });


  }


  getAddress(place: object) {

    this.addressDir = place['formatted_address'];
    this.address = place['geometry'];
    //this.registro.direccion = this.addressDir;

    this.lat = this.address.location.lat();
    this.lng = this.address.location.lng();

    this.afs.getAllRegionPro(this.user.companyId).then(res =>{

      res.forEach((doc)=>{
          //console.log(doc.id);
          //console.log(doc.data());

          let location = [ this.lat, this.lng];

          let idRegion = doc.id;
          let regionData = doc.data();
          let regionPolygon = doc.data().polygon;

          let  pointArr = [];

          Object.keys(regionPolygon).forEach((id) => {
              var point = [
                  regionPolygon[id].lat,
                  regionPolygon[id].lng,
              ];
              pointArr.push(point);
          });

          //console.log(pointArr);

          if(this.afs.inside(location, pointArr)){
              //console.log(regionData.name);
              this.regionName = regionData.name;
              this.region = idRegion;
              this.forma.controls['region'].setValue(this.regionName);
          }

      });

  }).catch(err=>{
      console.log(err);
  });


    this.forma.controls['latitude'].setValue(this.lat);
    this.forma.controls['longitude'].setValue(this.lng);
    this.forma.controls['address'].setValue(this.addressDir);


    const coordinates = new google.maps.LatLng(this.lat, this.lng);

    this.marker = new google.maps.Marker({
      position: coordinates,
      map: this.map
    })

    const mapOptions: google.maps.MapOptions = {
      // here to place centering our location based on coordinates
      center: coordinates,
      zoom: 18,
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false
      };

      this.map = new google.maps.Map(this.gmap.nativeElement, mapOptions);
      this.marker.setMap(this.map);
     }



     private getPlaceAutocomplete() {

      const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
          {
              componentRestrictions: { country: 'CO' },
              types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
          });
      google.maps.event.addListener(autocomplete, 'place_changed', () => {

          const place = autocomplete.getPlace();
         // console.log(place);
          this.getAddress(place);
          //this.invokeEvent(place);
      });
  }

}
